export default __webpack_public_path__ + "static/media/high-shot.78667676.png";